<template lang="pug">
  .main-form-layout
    v-layout.my-6(v-if="isFetching")
      v-row.fill-height.ma-0(align='center' justify='center')
        v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
    invoice-home(v-else-if="lead" :pid="lead.pid")
    v-layout.my-6(v-else)
      v-row.fill-height.ma-0(align='center' justify='center')
        div.mx-auto
          v-img.mx-auto(:src="require('@/assets/images/icon_empty.png')" style="width:80px; height:80px" contain)
          p.caption This url is no longer valid
</template>

<script>
import { mapState } from 'vuex'
import { setOptions, bootstrap } from 'vue-gtag'
import InvoiceHome from '@/views/invoice/Home'

export default {
  name: 'FormsHome',
  components: { InvoiceHome },
  props: ['formSlug'],
  data: () => ({
    isFetching: true,
    lead: null,
    isViewving: false,
  }),
  computed: {
    ...mapState('user', ['user']),
  },
  mounted () {
    if (window.location.hostname === 'yezza.link') {
      this.getRedirectLink()
      return
    }
    if (window.location.hostname === 'yzza.link') {
      this.getRedirectLink2()
      return
    }
    if (this.$route.query.preview && this.user) {
      this.isViewving = true
    }
    if (window.location.hostname === 'yezza.store' || 'store' in this.$route.query) {
      this.fetchLead()
    } else {
      let subdomain = window.location.host.split('.')[0]
      if (!subdomain || subdomain.includes('localhost') || subdomain.includes('192')) {
        subdomain = 'app'
      }
      let redirectUrl = `https://${subdomain}.${process.env.VUE_APP_SHORT_URL_DOMAIN}/${this.formSlug}`
      if (this.$route.query.preview) {
        redirectUrl += '?preview=true'
      }
      location.href = redirectUrl
    }
  },
  methods: {
    fetchLead () {
      this.$axios.get(`/leads/${this.formSlug}/`)
        .then((resp) => {
          this.lead = resp.data
          this.initPixel(this.lead.form.company.tracker)
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    initGtag (tracker) {
      if (!tracker.ga) {
        return
      }
      setOptions({
        config: { id: tracker.ga }
      })
      bootstrap().then((gtag) => {
        gtag('config', tracker.ga, {
          send_page_view: false
        })
        if (tracker.g_ads) {
          gtag('config', tracker.g_ads, {
            send_page_view: false
          })
        }
        gtag('event', 'purchase', {
          'value': this.totalPriceAmount
        })

        this.$gtag.pageview({
          page_title : this.lead.form.name,
          page_path: this.$route.path
        })
      })
    },
    initPixel (tracker) {
      if (!tracker || !tracker.fb) {
        return
      }
      window.fbq('init', tracker.fb)
      window.fbq('trackSingle', tracker.fb, 'PageView')
    },
    getRedirectLink () {
      const slug = window.location.pathname
      const queryString = window.location.search
      const urlParams = new URLSearchParams(queryString)
      const os = urlParams.get('os')
      this.$axios.get(`/partners${slug}/redirect_url`)
        .then(resp => {
          if (os) {
            window.location.href = `https://app.yezza.io/signup/${os}?af_id=`+ resp.data
          } else {
            window.location.href = `https://yezza.com?af_id=`+ resp.data 
          }
        })
        .catch(() => {
          window.location.href = `https://${process.env.VUE_APP_BASE_DOMAIN}`
        })
    },
    getRedirectLink2 () {
      const slug = window.location.pathname
      this.$axios.get(`/partners${slug}/redirect_url`)
        .then(resp => {
          window.location.href = `https://creators.yezza.com?af_id=`+ resp.data
        })
        .catch(() => {
          window.location.href = `https://creators.yezza.com`
        })
    }
  }
}
</script>
